import { render, staticRenderFns } from "./GetASingleOrder.vue?vue&type=template&id=abca461a"
import script from "./GetASingleOrder.vue?vue&type=script&lang=js"
export * from "./GetASingleOrder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports